import React, { useEffect, useState } from 'react';
import useBackendApi from '../../../hooks/useBackendApi';
import GradientCircularProgressContainer from '../../../components/common/GradientCircularProgressContainer';
import { useThemeContext } from '../../../contexts/ThemeContext.js';

const PipedriveConnect: React.FC = () => {
  const { apiFetchRequest } = useBackendApi();
  const [error, setError] = useState<string | null>(null);
  const { isMembershipDataReady } = useThemeContext();

  useEffect(() => {
    const connectPipedrive = async () => {
      try {
        if (!isMembershipDataReady) {
          return;
        }

        const urlParams = new URLSearchParams(window.location.search);
        const slackId = urlParams.get('slack_id');

        const response = await apiFetchRequest({
          endpoint: '/api/angie/auth/pipedrive/connect',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: { user_id: slackId },
        });

        if (response && !response.isError && response.body?.url) {
          window.location.href = response.body.url;
        } else {
          setError('Invalid response returned from server.');
        }
      } catch (err: unknown) {
        const message = err instanceof Error ? err.message : 'Failed to initiate connection to Pipedrive';
        setError(message);
      }
    };

    connectPipedrive();
  }, [apiFetchRequest, isMembershipDataReady]);

  if (error) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen">
        <p className="text-red-600 mb-4">{error}</p>
        <button onClick={() => window.location.reload()} className="px-4 py-2 bg-blue-500 text-white rounded">
          Try Again
        </button>
      </div>
    );
  }

  return <GradientCircularProgressContainer loadingMessage="Connecting to Pipedrive..." />;
};

export default PipedriveConnect;
